import { API_ENDPOINTS } from "./endpoints";
import { requestJson } from "./httpClient";
import { buildDocumentSavePayload } from "../utils/documentProcessorHydrators";

export class ProcessingError extends Error {
    constructor(message, details = {}) {
        super(message);
        this.name = "ProcessingError";
        this.failedRows = Array.isArray(details.failedRows) ? details.failedRows : [];
        this.partialProcessed = details.partialProcessed || "";
    }
}

const DOCUMENT_ENDPOINTS = {
    request: {
        textApi: API_ENDPOINTS.components.debugOrder,
        excelApi: API_ENDPOINTS.components.debugOrderExcel,
        saveApi: API_ENDPOINTS.orders.saveFromString
    },
    offer: {
        textApi: API_ENDPOINTS.components.debugOffer,
        excelApi: API_ENDPOINTS.components.debugOfferExcel,
        saveApi: API_ENDPOINTS.offers.saveFromString
    }
};

export const getDocumentProcessorEndpoints = (documentType) => DOCUMENT_ENDPOINTS[documentType];

export async function processTextRequest(apiUrl, text) {
    const data = await requestJson(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "text/plain" },
        body: text
    });

    if (data?.status === "error") {
        throw new ProcessingError(data.message || "Ошибка обработки документа", data);
    }

    return data;
}

export async function processExcelRequest(apiUrl, file) {
    const formData = new FormData();
    formData.append("file", file);

    const data = await requestJson(apiUrl, {
        method: "POST",
        body: formData
    });

    if (data?.status === "error") {
        throw new ProcessingError(data.message || "Ошибка обработки Excel документа", data);
    }

    return data;
}

export async function saveDocumentToDB(apiUrl, saveData) {
    return requestJson(apiUrl, {
        method: "POST",
        body: buildDocumentSavePayload(saveData)
    });
}
